import { observer } from 'mobx-react';
import { useTranslations } from '@vocab/react';
import * as styles from './DetailsView.css';
import Modal from '../../common/Modal';
import { MODAL_NAME } from '../../../constants/modals';
import type { IUiStore } from '../../../stores/UiStore';
import type { IJobApplication } from '../../../stores/JobApplicationStore/JobApplication';
import JobApplicationDetails from '../JobApplicationDetails';
import { Box, Drawer } from 'braid-design-system';
import translations from './.vocab';

interface Props {
  isMobile: boolean;
  uiStore: IUiStore;
  jobApplication: IJobApplication | null;
  onClose: () => void;
  questionnaireId?: string;
  isFromHirerActivity?: boolean;
  applicationCardIsExpanded?: boolean;
}

const DetailsView = ({
  uiStore,
  isMobile,
  jobApplication,
  onClose,
  questionnaireId,
  isFromHirerActivity = false,
  applicationCardIsExpanded,
}: Props) => {
  const { t } = useTranslations(translations);

  if (!jobApplication) {
    return null;
  }

  return (
    <Modal
      modalStore={uiStore.modalStore}
      name={MODAL_NAME.DETAILS_VIEW}
      closeButton={!isMobile}
      onCloseModal={onClose}
      showDraw
      renderCustomElement={({ isOpen, close }) => (
        <Drawer
          id="details-view-drawer"
          width="large"
          open={isOpen}
          onClose={() => close()}
          closeLabel={t('Close modal')}
          title={jobApplication.fullName}
        >
          <Box
            data-cy="job-application-details"
            className={styles.jobApplicationDetailsCard}
          >
            <JobApplicationDetails
              jobApplication={jobApplication}
              onClose={onClose}
              questionnaireId={questionnaireId}
              isFromHirerActivity={isFromHirerActivity}
              applicationCardIsExpanded={applicationCardIsExpanded}
            />
          </Box>
        </Drawer>
      )}
    />
  );
};

export default observer(DetailsView);
